export default function PHP_Switch() {
  return (
    <div>
      <h1>PHP_switch</h1>
    </div>
  );
}
